<template>
  <div>
    <!--    <el-button type="primary" @click="createCarportDialog = true">创建车库</el-button>-->
    <el-row>
      <el-col
        class="groud_card"
        :span="5"
        :xs="24"
        v-for="item in carportDetailList"
        :key="item.title"
      >
        <div class="groud_card_title">
          <div class="groud_card_icon" :style="{ background: item.bgc }">
            <Icon
              class="icon_logo"
              :style="{ color: item.color }"
              :icon="item.icon"
            />
          </div>
          <div class="groud_text">{{ item.title }}</div>
        </div>
        <div class="groud_card_value">
          <!-- 收费方式 -->
          <template v-if="item.key == 'charge' && params.carportId">
            <template v-if="carportDetailObj.allowTemporaryParking === 1">
              <div class="value_share">
                临停时长：{{ carportDetailObj.temporaryParkingTime }}小时
              </div>
              <div class="value_share">
                收费金额：{{ carportDetailObj.temporaryParkingMoney }}元
              </div>
            </template>
            <template v-else>不允许临时停车</template>
          </template>
          <!-- 包月套餐 -->
          <template v-if="item.key == 'power'">
            <div
              class="value_share"
              v-for="item in carportDetailObj.agentGetCarTypeMonthlyInfoList"
              :key="item.id"
            >
              {{ item.name }}, {{ item.money }}元{{
                getChargeMonthly(item.chargeMonthlyInfoId)
              }}
            </div>
          </template>
          <!-- 分润方 -->
          <!-- <template v-if="item.key == 'share'">
            <div
              class="value_share"
              v-for="item in carportDetailObj.groupDividendConfList"
              :key="item.id"
            >
              {{ item.dividend.name }}, 分润 {{ item.dividendRatio }}%
            </div>
          </template> -->
          <!-- 具体位置 -->
          <template v-if="item.key == 'address'">
            <div class="value_share">
              {{ carportDetailObj.address }}
            </div>
          </template>
          <!-- 联系电话 -->
          <template v-if="item.key == 'mobile'">
            <div class="value_share">
              {{
                carportDetailObj.deviceGroup &&
                carportDetailObj.deviceGroup.mobile
              }}
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="5" class="m-mp-10">
      <el-form ref="params" :model="params">
        <!--              ids、车棚、状态、网络-->
        <el-col :span="4" :xs="12">
          <el-form-item prop="carportId">
            <el-select
              v-model="params.carportId"
              filterable
              ref="select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
              placeholder="车库"
              value="groupingValue"
              @change="handleParamsQuery"
              clearable
            >
              <el-option
                v-for="item in carportList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4" :xs="24"> 
          <el-form-item prop="ids">
            <el-input
              v-model="params.ids"
              maxlength="5"
              placeholder="硬件UID"
            />
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="3" :xs="12">
          <el-form-item prop="state">
            <el-select v-model="params.state" placeholder="状态">
              <el-option
                v-for="item in status"
                :key="item.label"
                :label="item.label"
                :value="item.value"
                @change="handleParamsQuery"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="3" :xs="12">
          <el-form-item prop="onLine">
            <el-select v-model="params.onLine" placeholder="网络">
              <el-option
                v-for="item in onLines"
                :key="item.label"
                :label="item.label"
                :value="item.value"
                @change="handleParamsQuery"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="12">
          <el-form-item prop="qrCodeId">
            <el-input v-model="params.qrCodeId" placeholder="门禁二维码编号" />
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button type="primary" @click="handleParamsQuery">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="6">
          <el-button plain type="success" @click="handleResetBtnClick"
            >重置</el-button
          >
        </el-col>
      </el-form>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="6" :xs="24" v-for="item in records" :key="item.id">
        <lp-list-item :item="item" :rows="dataRows">
          <template #option="scope">
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button
                type="warning"
                size="mini"
                @click="accessControlConfig(scope.row)"
                >射频配置</el-button
              >
            </div>
            <div v-if="scope.row" style="margin: 0 10px 8px 0">
              <el-button
                type="primary"
                size="mini"
                @click="generateQrcode(scope.row)"
                >二维码</el-button
              >
            </div>
          </template>
        </lp-list-item>
      </el-col>
    </el-row>

    <!-- <el-table
      v-loading="loadTable"
      :data="records"
      stripe
      @sort-change="sort_change"
    >
      <el-table-column
        fixed
        label="门禁二维码编号"
        prop="accessControlDeviceQrCode.id"
      /> 
      <el-table-column label="状态">
        <template #default="scope">
          <template v-if="scope.row.state === 1"> 已绑定 </template>
          <template v-else-if="scope.row.state === 0"> 未绑定 </template>
          <template v-else-if="scope.row.state === -1"> 报废 </template>
        </template>
      </el-table-column>
      <el-table-column label="网络">
        <template #default="scope">
          <template v-if="scope.row.onLine"> 在线 </template>
          <template v-else> 离线 </template>
        </template>
      </el-table-column>
      <el-table-column label="所属车库" prop="carport.name" />

      <el-table-column label="创建时间" prop="creatTime">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="generateQrcode(scope.row)"
            >二维码</el-button
          > 
        </template>
      </el-table-column>
    </el-table> -->

    <page :current="current" :size="size" :total="total" />
    <create-carport-dialog :dialog="createCarportDialog" />
    <a id="downloadLink"></a>

    <!-- 门禁二维码弹框 -->
    <el-dialog
      title="门禁二维码"
      v-if="showGenerateQrcodeDialog"
      :visible.sync="showGenerateQrcodeDialog"
      :fullscreen="dialogFullscreen"
      @close="handleQrcodeDialogClose"
    >
      <div class="qrcode_wrapper">
        <div
          ref="qrcodeRef"
          v-for="item in currGenerateQrcodeRow.version == '1.0' ? 2 : 1"
          :key="item"
          class="qrcode_box"
        >
          <div class="box_title">
            <span v-if="currGenerateQrcodeRow.version == '1.0'">{{
              item == 1 ? "进门" : "出门"
            }}</span>
            <el-button
              type="primary"
              style="margin-left: 5px"
              @click="handleQrcodeDownLoad(item - 1)"
              >下载图片</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 更换门禁弹框 -->
    <el-dialog
      title="更换门禁"
      width="25%"
      v-if="showReplaceAccessControlDialog"
      :visible.sync="showReplaceAccessControlDialog"
      :fullscreen="dialogFullscreen"
      @close="handleReplaceAccessControlDialogClose"
    >
      <div class="replace_wrapper">
        <el-input v-model="currentAccessControl.id" disabled>
          <template slot="prepend">旧门禁编号</template>
        </el-input>
        <div style="height: 20px"></div>
        <el-input placeholder="请输入新门禁编号" v-model="replaceNewQrcode">
          <template slot="prepend">新门禁编号</template>
          <template slot="append">
            <el-button plain type="success" @click="scanNewQrcode"
              >扫码获取</el-button
            >
          </template>
        </el-input>
      </div>
      <div slot="footer">
        <el-button @click="handleReplaceAccessControlDialogCancel"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="handleReplaceAccessControlDialogConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 门禁配置弹框 -->
    <el-dialog
      title="射频配置"
      v-if="showConfigAccessControlDialog"
      :visible.sync="showConfigAccessControlDialog"
      :fullscreen="dialogFullscreen"
      @close="handleAccessControlDialogClose"
    >
      <div class="config_wrapper">
        <div class="config_version">射频版本：{{ currRFVersionStr }}</div>

        <div class="config_btns">
          <div class="cb_item">
            <el-button
              type="primary"
              size="mini"
              @click="handleAccessFactoryReset"
              >恢复出厂设置</el-button
            >
          </div>
          <div class="cb_item">
            <el-button
              type="primary"
              size="mini"
              @click="handleAccessBuzzerReset"
              >设置蜂鸣器</el-button
            >
          </div>
          <div class="cb_item">
            <el-button
              type="primary"
              size="mini"
              @click="handleAccessVersionReset"
              >查询射频版本号</el-button
            >
          </div>
          <div class="cb_item">
            <el-button type="primary" size="mini" @click="handleAccessWorkReset"
              >设置工作模式</el-button
            >
          </div>
        </div>

        <el-divider />

        <div class="config_point">
          <div class="config_title">设置频点：</div>

          <el-radio-group
            v-model="currRFConfigParams.point"
            @change="handleAccessRFPointChange"
          >
            <el-radio-button label="1">A</el-radio-button>
            <el-radio-button label="2">B</el-radio-button>
            <el-radio-button label="3">C</el-radio-button>
          </el-radio-group>
        </div>

        <el-divider />

        <div class="config_distance">
          <div class="config_title">设置距离：</div>

          <div class="config_wrapper">
            <div class="config_box_wrapper">
              <div class="wrapper_label">距离(值越大距离越远):</div>
              <el-input-number
                v-model="currRFConfigParams.distance"
                :min="0"
                :max="33"
              ></el-input-number>
            </div>

            <div class="config_box_wrapper">
              <div class="wrapper_label">循环间隔时间(ms):</div>
              <el-input-number
                v-model="currRFConfigParams.loopInterval"
                :min="100"
                :max="1000"
              ></el-input-number>
            </div>

            <el-button
              type="primary"
              @click="handleAccessRFSendDistanceAndInterval"
              >点击发送</el-button
            >
          </div>
        </div>

        <el-divider />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import adminGetAccessControlDeviceHardwareConfig from "@/api/device/access-control-device-controler/agentGetAccessControlDeviceHardwareConfig";
import adminSendToAccessControlDevice from "@/api/device/access-control-device-controler/agentSendToAccessControlDevice";
import adminSendToAccessControlDeviceWithOutBack from "@/api/device/access-control-device-controler/agentSendToAccessControlDeviceWithOutBack";
import adminSetAccessControlDeviceHardwareConfig from "@/api/device/access-control-device-controler/agentSetAccessControlDeviceHardwareConfig";

import Page from "@/components/Page";
import dialogMixin from "@/mixin/dialogMixin";
import pageMixin from "@/mixin/pageMixin";
import CreateCarportDialog from "@/views/GarageManage/dialog/createAndEditCarportDialog";
// import createdMixin from "@/mixin/createdMixin";
import CarPort from "@/api/device/CarPort";
import agentGetAccessControlerDeviceByPage from "@/api/device/access-control-device-controler/agentGetAccessControlerDeviceByPage";
import agentReplaceAccessControlDevice from "@/api/device/access-control-device-controler/agentReplaceAccessControlDevice";
import agentUnBindAccessControlDevice from "@/api/device/access-control-device-controler/agentUnBindAccessControlDevice";
import agentGetGroupDetailById from "@/api/device/device-group-manage/agentGetGroupDetailById";
import resDispose from "@/mixin/resDisposeMixin";
import scanMixin from "@/mixin/scanMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import { Message } from "element-ui";
import QRCode from "qrcodejs2";

import LpListItem from "@/components/LpListItem.vue";

export default {
  name: "AccessControlDeviceOne",
  components: { CreateCarportDialog, Page, LpListItem },
  mixins: [
    pageMixin,
    dialogMixin,
    timeMixin,
    resDispose,
    searchMixin,
    scanMixin,
  ],
  data() {
    return {
      chargeMonthlyInfoList: [],
      showGenerateQrcodeDialog: false,
      carportDetailList: [
        {
          title: "临停收费",
          key: "charge",
          icon: "icon-shoufeiguanli",
          color: "#f83f3a",
          bgc: "rgba(248, 63, 58, 0.1)",
        },
        {
          title: "车辆类型包月套餐",
          key: "power",
          icon: "icon-yuebao",
          color: "#f1a00e",
          bgc: "rgba(244, 182, 70, 0.1)",
        },
        // {
        //   title: "分润方",
        //   key: "share",
        //   icon: "icon-zhjf",
        //   color: "#29c19b",
        //   bgc: "rgba(41, 193, 155, 0.1)",
        // },
        {
          title: "具体位置",
          key: "address",
          icon: "icon-weizhi",
          color: "#4d9aff",
          bgc: "rgba(130, 184, 255,0.1)",
        },
        {
          title: "联系电话",
          key: "mobile",
          icon: "icon-24gf-phoneLoudspeaker",
          color: "#e600ac",
          bgc: "rgba(255, 102, 204, 0.1)",
        },
      ],
      carportDetailObj: {},
      createCarportDialog: false,
      showReplaceAccessControlDialog: false,
      currentAccessControl: {},
      records: [],
      params: {
        pageNum: 1,
        size: 10,
        ids: "",
        carportName: "",
        state: "",
        onLine: "",
        sortName: "id",
        sortType: "DESC",
        carportId: undefined,
        qrCodeId: "",
      },
      carportList: [],
      status: [
        { value: "1", label: "已绑定" },
        // { value: "0", label: "未绑定" },
        { value: "-1", label: "报废" },
      ],
      onLines: [
        { value: "1", label: "在线 " },
        { value: "0", label: "离线" },
      ],
      replaceNewQrcode: "",
      currGenerateQrcodeRow: {},
      dataRows: [
        {
          label: "门禁二维码编号",
          prop: "accessControlDeviceQrCode.id",
        },
        {
          label: "ids",
          prop: "ids",
        },
        {
          label: "网络",
          prop: "onLine",
          format: (v) => (v ? "在线" : "离线"),
        },
        { label: "所属车库", prop: "carport.name" },
        {
          label: "创建时间",
          prop: "creatTime",
          format: (v) => this.timeFormat(v),
        },
      ],
      showConfigAccessControlDialog: false,
      currAccessControlRow: {},
      accessControlLoading: false,
      currRFVersionStr: "", // 当前射频设备版本号
      currRFConfigParams: {
        point: "1", // 当前射频设备频点
        distance: 5, // 当前射频设备距离
        loopInterval: 100, // 当前射频设备循环间隔时间
      },
    };
  },
  created() {
    this.loadTable = false;

    CarPort.agentGetAllCarport().then((res) => {
      this.carportList = res.data;
      if (!this.params.carportId) {
        if (this.$route.query.carportId) {
          this.params.carportId = +this.$route.query.carportId;
        } else if (this.carportList.length == 1) {
          this.params.carportId = this.carportList[0].id;
        }
      }

      if (this.$route.query.status) {
        this.params.onLine = this.$route.query.status;
      }
      // if (this.params.carportId)
      this.fetchData();
    });
  },
  remove(id) {
    agentUnBindAccessControlDevice({ accessControlDeviceId: id }).then(
      (res) => {
        this.resFetch({ res });
      }
    );
  },
  watch: {
    "params.carportId": {
      handler() {
        this.getCarportDetailById(this.params.carportId);
      },
    },
  },
  methods: {
    handleAccessControlDialogClose() {},
    // 射频配置
    accessControlConfig(row) {
      console.log(row);

      // 获取当前门禁射频设备配置信息
      adminGetAccessControlDeviceHardwareConfig(row.ids).then((res) => {
        if (res.data && res.data.configInfo) {
          this.currRFConfigParams = JSON.parse(res.data.configInfo);
        }
      });

      this.currAccessControlRow = row;
      this.showConfigAccessControlDialog = true;
      this.accessControlLoading = false;
      this.currRFVersionStr = "";
    },
    // 门禁配置-恢复出厂设置
    handleAccessFactoryReset() {
      this.handleSendAccessData(
        {
          id: this.currAccessControlRow.ids,
          hexStr: "D904010041E1",
        },
        "D9060100410000DF",
        true,
        false
      );
    },
    // 门禁配置-设置蜂鸣器
    handleAccessBuzzerReset() {
      this.handleSendAccessData(
        {
          id: this.currAccessControlRow.ids,
          hexStr: "D90501004501DB",
        },
        "D9060100450000DB",
        true,
        false
      );
    },
    // 门禁配置-查询版本号
    handleAccessVersionReset() {
      this.handleSendAccessData(
        {
          id: this.currAccessControlRow.ids,
          hexStr: "D90401001012",
        },
        "",
        false
      );
    },
    // 门禁配置-设置工作模式
    handleAccessWorkReset() {
      this.handleSendAccessData(
        {
          id: this.currAccessControlRow.ids,
          hexStr: "D9080100512B000000A2",
        },
        "D9060100510000CF",
        true,
        false
      );
    },
    // 门禁配置-射频频点
    handleAccessRFPointChange() {
      if (this.currRFConfigParams.point == "1") {
        this.handleSendAccessData(
          {
            id: this.currAccessControlRow.ids,
            hexStr: "D90A01006001000B000000B0",
          },
          "D9060100600000C0"
        );
      } else if (this.currRFConfigParams.point == "2") {
        this.handleSendAccessData(
          {
            id: this.currAccessControlRow.ids,
            hexStr: "D90A010060010F1B00000091",
          },
          "D9060100600000C0"
        );
      } else if (this.currRFConfigParams.point == "3") {
        this.handleSendAccessData(
          {
            id: this.currAccessControlRow.ids,
            hexStr: "D90A010060011F2F0000006D",
          },
          "D9060100600000C0"
        );
      }

      // 保存当前门禁射频设备配置信息
      adminSetAccessControlDeviceHardwareConfig({
        ids: this.currAccessControlRow.ids,
        configInfo: JSON.stringify(this.currRFConfigParams),
      }).then((res) => {
        console.log(res);
      });
    },
    toSmallEndHex(value) {
      return Number(value)
        .toString(16)
        .padStart(4, "0")
        .match(/.{2}/g)
        .reverse()
        .join("")
        .toUpperCase();
    },
    /**
     * 校验和计算
     * @param {string} hex 十六进制字符串
     * @returns {string} 两位十六进制校验码
     */
    CKSum(hex) {
      let uSum = 0;

      for (let i = 0; i < hex.length; i += 2) {
        uSum = (uSum + parseInt(hex.substr(i, 2), 16)) & 0xff;
      }

      return ((~uSum + 1) & 0xff).toString(16).toUpperCase().padStart(2, "0");
    },
    // 门禁配置-射频距离和循环间隔时间
    handleAccessRFSendDistanceAndInterval() {
      let sendHexStr = `D94301006280000000${this.currRFConfigParams.distance
        .toString(16)
        .padStart(2, "0")
        .toUpperCase()}1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E1E0000000000000000010000000000000064000000${this.toSmallEndHex(
        this.currRFConfigParams.loopInterval
      )}0000000000`;
      // 计算CRC
      sendHexStr += this.CKSum(sendHexStr);
      console.log(sendHexStr);

      this.handleSendAccessData(
        {
          id: this.currAccessControlRow.ids,
          hexStr: sendHexStr,
        },
        "D9060100620000BE"
      );

      // 保存当前门禁射频设备配置信息
      adminSetAccessControlDeviceHardwareConfig({
        ids: this.currAccessControlRow.ids,
        configInfo: JSON.stringify(this.currRFConfigParams),
      }).then((res) => {
        console.log(res);
      });
    },
    /**
     * 停止盘点，最多重试3次
     * @param {Object} data 请求参数
     * @returns {Promise<boolean>} 是否停止盘点成功
     */
    async stopAccessControlInventory(data) {
      const maxRetries = 3;
      const successResponse = "D90601002F0000F1";

      for (let i = 1; i <= maxRetries; i++) {
        try {
          const sendRequest =
            this.currAccessControlRow.id < 250
              ? adminSendToAccessControlDeviceWithOutBack
              : adminSendToAccessControlDevice;

          const res = await sendRequest({
            ...data,
            hexStr: "D90401002FF3",
          });

          if (res.code == 1 && res.data == successResponse) {
            return true;
          }

          if (i === maxRetries) {
            if (res.code != 1) {
              this.$message.error(
                "配置失败，停止盘点失败：" +
                  (res.msg || "未知错误") +
                  "，已重试3次"
              );
            } else {
              this.$message.error("配置失败，停止盘点响应数据有误，已重试3次");
            }
          }
        } catch (err) {
          if (i === maxRetries) {
            this.$message.error(
              "配置失败，停止盘点请求异常：" +
                (err.msg || err.message || "未知错误") +
                "，已重试3次"
            );
          }
        }
      }

      return false;
    },
    // 解析设备版本号
    parseVersion(data) {
      if (!data || data.length < 10) return [];

      // 去掉最后两位
      const str = data.slice(0, -2);

      // 截取末尾8位版本数据
      const hex = str.slice(-8);

      if (!/^[0-9a-fA-F]{8}$/.test(hex)) return [];

      // 每4位解析一组，每两个字符转为十进制
      return hex.match(/.{4}/g).map((item) => {
        const major = parseInt(item.slice(0, 2), 16);
        const minor = parseInt(item.slice(2, 4), 16);

        return `${String(major).padStart(2, "0")}.${String(minor).padStart(
          2,
          "0"
        )}`;
      });
    },
    /**
     * 发送指令到门禁
     */
    async handleSendAccessData(
      data,
      responseStr = "",
      isJudgeResponse = true,
      isSendMode = true
    ) {
      // 防止重复点击
      if (this.accessControlLoading) return;

      this.accessControlLoading = true;

      // 全屏 Loading
      const loading = this.$loading({
        lock: true,
        text: "正在配置中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      try {
        // 停止盘点，最多重试3次
        const stopSuccess = await this.stopAccessControlInventory(data);
        if (!stopSuccess) return;

        // 根据设备ID区分新老设备
        const isOldDevice = this.currAccessControlRow.id < 250;

        // 发送配置指令
        const sendRequest = isOldDevice
          ? adminSendToAccessControlDeviceWithOutBack
          : adminSendToAccessControlDevice;

        // 老设备保留原有200ms延迟
        if (isOldDevice) {
          await new Promise((resolve) => setTimeout(resolve, 200));
        }

        const res = await sendRequest(data);

        if (res.code != 1) {
          this.$message.error("配置失败，" + (res.msg || "未知错误"));
          return;
        }

        if (isJudgeResponse && res.data != responseStr) {
          this.$message.error("配置失败，响应数据有误");
          return;
        }

        // 如果是查询版本号，则显示当前射频设备版号信息
        if (data.hexStr == "D90401001012") {
          // 解析硬件版本号和软件版本号
          // D93401001047442D5A524D3230303453563200000000000000000000000000000000000000000000000000611B020600000A000211EF
          let hardwareVersion = "未知";
          let softwareVersion = "未知";
          if (res.data.startsWith("D934")) {
            // 开始解析版本信息
            const arr = this.parseVersion(res.data);
            hardwareVersion = arr[0];
            softwareVersion = arr[1];
          }
          this.currRFVersionStr = `硬件版本:${hardwareVersion}，软件版本:${softwareVersion}`;
        }

        // 设置运行模式
        if (isSendMode) {
          // 老设备原逻辑中，配置指令完成后还会等待200ms
          if (isOldDevice) {
            await new Promise((resolve) => setTimeout(resolve, 200));
          }

          const modeRes = await sendRequest({
            ...data,
            hexStr: "D9080100512B000000A2",
          });

          if (modeRes.code != 1) {
            this.$message.error("配置失败，" + (modeRes.msg || "未知错误"));
            return;
          }

          if (modeRes.data != "D9060100510000CF") {
            this.$message.error("配置失败，设置工作模式响应数据有误");
            return;
          }
        }

        this.$message.success("配置成功~");
      } catch (err) {
        this.$message.error(
          "配置失败，" + (err.msg || err.message || "未知错误")
        );
      } finally {
        // 无论成功、失败或提前 return，都会执行
        loading.close();
        this.accessControlLoading = false;
      }
    },
    handleQrcodeDialogClose() {},
    handleReplaceAccessControlDialogClose() {},
    generateQrcode(row) {
      this.currGenerateQrcodeRow = row;
      this.showGenerateQrcodeDialog = true;

      this.$nextTick(() => {
        // 进
        this.generatorQrcodeFn(
          `http://wechat.hc17888.com/TemporaryParking?accessControlDeviceId=${row.accessControlDeviceQrCode.id}&io=1&agentCode=06595eebe6c140c4b63828d7d1ab8ead`,
          String(row.accessControlDeviceQrCode.id).padStart(6, 0),
          this.$refs.qrcodeRef[0]
        );
        // new QRCode(this.$refs.qrcodeRef[0], {
        //   text: `http://wechat.hc17888.com/TemporaryParking?accessControlDeviceId=${row.id}&io=1&agentCode=06595eebe6c140c4b63828d7d1ab8ead`,
        //   width: 200,
        //   height: 200,
        //   colorDark: "#000",
        //   colorLight: "#fff",
        //   correctLevel: QRCode.CorrectLevel.H,
        // });

        // 版本1.0的门禁才显示两个二维码
        if (row.version == "1.0") {
          // 出
          this.generatorQrcodeFn(
            `http://wechat.hc17888.com/TemporaryParking?accessControlDeviceId=${row.accessControlDeviceQrCode.id}&io=0&agentCode=06595eebe6c140c4b63828d7d1ab8ead`,
            String(row.accessControlDeviceQrCode.id).padStart(6, 0),
            this.$refs.qrcodeRef[1]
          );
        }

        // new QRCode(this.$refs.qrcodeRef[1], {
        //   text: `http://wechat.hc17888.com/TemporaryParking?accessControlDeviceId=${row.id}&io=0&agentCode=06595eebe6c140c4b63828d7d1ab8ead`,
        //   width: 200,
        //   height: 200,
        //   colorDark: "#000",
        //   colorLight: "#fff",
        //   correctLevel: QRCode.CorrectLevel.H,
        // });
      });
    },
    generatorQrcodeFn(qrCodeUrl, qrcodeText, qrcodeDom = null) {
      let qrcodeContent = qrcodeDom || document.createElement("div");
      qrcodeContent.width = "600px";
      qrcodeContent.height = "600px";
      let qrcodeCanvas = new QRCode(qrcodeContent, {
        text: qrCodeUrl, // 需要转换为二维码的内容
        width: 600,
        height: 600,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      let resolutionMultiple = 1; // 分辨率倍数
      let borderSize = 15 * resolutionMultiple; // 边框留白
      let canvasWidth = 600 * resolutionMultiple; // 图片宽度
      // 判断 参数为空的命名情况
      let text = qrcodeText; // 底部文字
      let fontSize = 20 * resolutionMultiple; // 文字大小

      let canvasHeight = canvasWidth + fontSize + 15;
      let canvas = document.createElement("canvas");
      if (!canvas.getContext) return;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      let ctx = canvas.getContext("2d");
      ctx.fillStyle = "rgb(255,255,255)"; // 调色(纯白)
      ctx.fillRect(0, 0, canvasWidth, canvasHeight); // 绘制背景

      let qrcodeSize = canvasWidth - borderSize * 2;
      ctx.drawImage(
        qrcodeContent.querySelector("canvas"),
        borderSize,
        borderSize,
        qrcodeSize,
        qrcodeSize
      ); // 填充二维码

      ctx.fill(); // 填充背景

      ctx.fillStyle = "rgb(0,0,0)"; // 调色(纯黑)
      ctx.font = fontSize + "px Arial"; // 文本大小, 字体
      ctx.textAlign = "center";
      ctx.fillText(
        text,
        canvasWidth / 2,
        qrcodeSize + borderSize + fontSize + 15,
        qrcodeSize
      ); // 绘制文本
      // 清除原二维码
      qrcodeCanvas.clear();
      [...qrcodeContent.querySelectorAll("canvas, img")].forEach((e) =>
        e.remove()
      );
      qrcodeContent.appendChild(canvas);
      return qrcodeContent;
    },
    replaceAccessControl(row) {
      this.replaceNewQrcode = "";
      this.currentAccessControl = { ...row };
      this.showReplaceAccessControlDialog = true;
    },
    handleReplaceAccessControlDialogCancel() {
      this.showReplaceAccessControlDialog = false;
    },
    handleReplaceAccessControlDialogConfirm() {
      if (!this.replaceNewQrcode.replace(/\s/g, "")) {
        return Message({
          message: "请先输入新门禁编号!",
          type: "error",
          duration: 1500,
        });
      }
      agentReplaceAccessControlDevice(
        this.currentAccessControl.id,
        this.replaceNewQrcode
      ).then((res) => {
        this.resFetch({ res });
        if (res.code == 1) {
          this.showReplaceAccessControlDialog = false;
        }
      });
    },
    scanNewQrcode() {
      this.scan({
        callBack: (res) => {
          const isLink = res.resultStr.substring(0, 4) === "http";

          if (!isLink) {
            return this.$message.error("请扫门禁设备的二维码~");
          }
          let strList = res.resultStr.split("?");
          if (strList.length === 2) {
            let argList = strList[1].split("&");
            if (argList.length === 3) {
              if (argList[0].startsWith("accessControlDeviceId=")) {
                this.replaceNewQrcode = argList[0].split("=")[1];
              } else {
                Message.error("二维码错误");
              }
            } else {
              Message.error("二维码错误");
            }
          } else {
            Message.error("二维码错误");
          }
        },
      });
    },
    delAccessControl(row) {
      this.$confirm("确认删除该门禁?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        agentUnBindAccessControlDevice({ accessControlDeviceId: row.id }).then(
          (res) => {
            // this.resFetch({ res });
            Message({
              message: res.code === 1 ? "删除成功~" : "删除失败!",
              type: res.code === 1 ? "success" : "error",
              duration: 3 * 1000,
            });
            this.fetchData();
          }
        );
      });
    },
    handleQrcodeDownLoad(i) {
      let img = this.$refs.qrcodeRef[i].children[1];
      // 构建画布
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      // 构造url
      let url = canvas.toDataURL("image/png");
      // 构造a标签并模拟点击
      let downloadLink = document.getElementById("downloadLink");
      downloadLink.setAttribute("href", url);
      downloadLink.setAttribute("download", `${i == 0 ? "进门" : "出门"}.png`);
      downloadLink.click();
    },
    handleResetBtnClick() {
      this.reset(
        this.$route.query.carportId ? { notResetFields: ["carportId"] } : {}
      );
    },
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    getCarportDetailById(id) {
      if (!id) return (this.carportDetailObj = {});

      CarPort.agentGetCarportById({ carportId: id }).then((res) => {
        console.log(res);
        this.carportDetailObj = res.data;
        agentGetGroupDetailById({ id: res.data.groupId }).then((res) => {
          this.chargeMonthlyInfoList = res.data.monthlyInfoList || [];
        });
      });
    },
    sort_change(e) {
      this.params.sortName = e.prop;
      this.params.sortType = e.order == "descending" ? "DESC" : "ASC";
      if (e.order == null) {
        this.params.sortName = null;
        this.params.sortType = null;
      }
      // console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData();
    },
    handleParamsQuery() {
      this.current = 1;
      this.fetchData();
    },
    fetchData() {
      this.params.pageNum = this.current;
      this.params.size = this.size;
      agentGetAccessControlerDeviceByPage(this.params).then((res) => {
        this.records = res.data.records;
        if (this.params.ids) {
          const unique = new Set(this.records.map((r) => r.carportId));
          // 如果设备都在同一小区，则自动选中该小区，显示详细信息
          if (unique.size == 1) {
            this.$set(this.params, "carportId", this.records[0].carportId);
          }
        }

        this.total = res.data.total;
        //   console.log('===========================')
        //   console.log(res.data.records)
        // console.log('===========================')
      });
    },
    reset2() {
      this.params = {
        pageNum: 1,
        size: 10,
        ids: "",
        carportName: "",
        state: "",
        onLine: "",
        sortName: this.params.sortName,
        sortType: this.params.sortType,
        carportId: this.params.carportId,
      };
      if (this.time) {
        delete this.params.startTime;
        delete this.params.endTime;
        this.time = [];
        this.current = 1;
      }
      this.fetchData();
    },
    getChargeMonthly(chargeId) {
      const item = this.chargeMonthlyInfoList.find((c) => c.id == chargeId);
      return item
        ? ` - 最大功率${item.endPower}W,${item.money}元,${item.freeChargeNum}小时`
        : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .wrapper {
    .card {
      height: 80px !important;
      padding-left: 10px !important;
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 10px !important;
  }
}
</style>

<style lang="scss" scoped>
@import "src/styles/my";
@include mobile {
  .card {
    height: 65px !important;
  }

  // .groud_card {
  //   .groud_card_value {
  //     height: 90px !important;
  //   }
  // }

  /deep/ .el-form-item {
    margin-bottom: 10px !important;
  }

  .groud_card {
    .groud_card_value {
      height: auto !important;
      max-height: 90px !important;
    }
  }

  .qrcode_wrapper {
    flex-direction: column;
    .qrcode_box {
      margin-bottom: 40px;
      margin-right: 0;
    }
  }

  .config_distance {
    div.config_wrapper {
      flex-direction: column;
      align-items: flex-start;
    }
    div.config_box_wrapper {
      margin-bottom: 15px;
    }
  }

  .config_btns {
    .cb_item {
      width: 50% !important;
      flex: none !important;
    }
  }
}

.config_wrapper {
  .config_version {
    font-size: 15px;
    margin-bottom: 24px;
  }

  .config_title {
    font-size: 15px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .config_btns {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .cb_item {
      flex: 1;
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
    }
  }

  .config_point {
  }

  .config_wrapper {
    display: flex;
    align-items: center;

    .config_box_wrapper {
      margin-right: 20px;

      .wrapper_label {
        margin-bottom: 10px;
      }
    }
  }
}

.qrcode_wrapper {
  // display: flex;
  // justify-content: space-around;
  // align-items: center;
  .qrcode_box {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-right: 30px;
    .box_title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}

.groud_card {
  box-sizing: border-box;
  // cursor: pointer;
  border: 1px solid #f0f0f0;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 3px 5px;
  // display: flex;
  // align-items: center;
  // padding-left: 30px;
  margin-right: 16.5px;
  margin-bottom: 8px;
  border-radius: 5px;

  .groud_card_title {
    display: flex;
    align-items: center;
    // justify-content: center;
    // margin-bottom: 4px;
    font-size: 14px;
    // border-bottom: 1px solid #f4f4f4;
    padding-bottom: 5px;
    padding: 5px;
    box-shadow: 0 1px 3px #e3e3e3;

    .groud_card_icon {
      margin-right: 8px;
      // padding: 2px 3px;
      border-radius: 4px;

      .icon_logo {
        font-size: 22px;
      }
    }

    .groud_text {
      font-weight: bold;
      letter-spacing: 1px;
    }
  }

  .groud_card_value {
    padding: 4px 8px;
    height: 100px;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    font-size: 14px;

    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    .value_share {
      border-bottom: 1px dashed #e4e4e4;
      margin-bottom: 3px;
      padding-bottom: 2px;
    }
  }
}
</style>
